import { render } from "./markettrends-tab.vue?vue&type=template&id=358d1553"
import script from "./markettrends-tab.js?vue&type=script&lang=js"
export * from "./markettrends-tab.js?vue&type=script&lang=js"

import "./markettrends-tab.vue?vue&type=style&index=0&id=358d1553&lang=css"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__